/* Gastrolux PDP sticky purchase bar. Reuses native Shopify form and variant selection. */
(function(){
  function init(){
    if(document.querySelector('.floating-atc')||!document.querySelector('[data-section-type="product-template"]'))return;
    const area=document.querySelector('.product-area[data-product-id]')||document.querySelector('.product-area');
    const original=document.querySelector('.product-detail__form__action button[name="add"],.product-detail__form__action input[name="add"]');
    const originalWrap=original?.closest('.product-detail__form__action');
    if(!area||!original||!originalWrap)return;
    const form=original.closest('form');
    if(!form)return;
    let product=null;
    const source=document.querySelector('script[id^="cc-product-json-"]');
    try{if(source)product=JSON.parse(source.textContent)}catch(error){console.warn('Gastrolux sticky: product JSON inaccessible',error)}
    const bar=document.createElement('div');
    bar.className='floating-atc';
    bar.setAttribute('role','region');
    bar.setAttribute('aria-label','Ajout rapide au panier');
    const productBlock=document.createElement('div');
    productBlock.className='floating-atc__product';
    const photo=document.createElement('img');
    photo.className='floating-atc__photo';
    photo.width=54;photo.height=65;photo.alt='';
    photo.loading='lazy';
    const picture=area.querySelector('.product-area__media img');
    photo.src=(typeof product?.featured_image==='string'?product.featured_image:product?.featured_image?.src)||picture?.currentSrc||picture?.src||'';
    if(photo.src)productBlock.appendChild(photo);
    const text=document.createElement('div');
    text.className='floating-atc__details';
    const title=document.createElement('strong');
    title.className='floating-atc__title';
    title.textContent=area.querySelector('.product-area__details__title')?.textContent?.trim()||product?.title||'Votre ustensile Gastrolux';
    const options=document.createElement('div');options.className='floating-atc__option-row';
    const variant=document.createElement('span');variant.className='floating-atc__variant';
    const change=document.createElement('button');
    change.type='button';change.className='floating-atc__change';change.textContent='Modifier';
    change.addEventListener('click',()=>{
      const target=area.querySelector('.product-detail__form__options .selector-wrapper, .product-detail__form__options, .selector-wrapper');
      if(target){target.scrollIntoView({behavior:'smooth',block:'center'});const el=target.querySelector('.clickyboxes a.active,.clickyboxes a,select');if(el)setTimeout(()=>el.focus({preventScroll:true}),400)}
    });
    options.append(variant,change);text.append(title,options);productBlock.appendChild(text);
    const purchase=document.createElement('div');purchase.className='floating-atc__purchase';
    const quantityWrap=document.createElement('div');quantityWrap.className='floating-atc__quantity';
    const dec=document.createElement('button');dec.type='button';dec.textContent='−';dec.setAttribute('aria-label','Diminuer la quantité');
    const qty=document.createElement('output');qty.className='floating-atc__number';qty.setAttribute('aria-label','Quantité');
    const inc=document.createElement('button');inc.type='button';inc.textContent='+';inc.setAttribute('aria-label','Augmenter la quantité');
    quantityWrap.append(dec,qty,inc);
    const buy=document.createElement('button');buy.type='button';buy.className='floating-atc__btn';
    const buyLabel=document.createElement('span');buyLabel.className='floating-atc__buy-label';
    const buyPrice=document.createElement('span');buyPrice.className='floating-atc__buy-price';
    buy.append(buyLabel,buyPrice);purchase.append(quantityWrap,buy);bar.append(productBlock,purchase);document.body.appendChild(bar);
    const input=form.querySelector('input[name="quantity"]');
    function getQty(){return Math.max(1,Number(input?.value)||1)}
    function setQty(n){const value=Math.max(1,Math.min(99,Number(n)||1));if(input){input.value=value;input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}))}qty.textContent=String(value)}
    dec.addEventListener('click',()=>setQty(getQty()-1));inc.addEventListener('click',()=>setQty(getQty()+1));
    buy.addEventListener('click',()=>{if(!buy.disabled)original.click()});
    function selectedVariant(){
      const wrappers=[...area.querySelectorAll('.product-detail__form__options .selector-wrapper[data-option-name]')];
      let byOpts=null;
      if(product?.variants?.length&&wrappers.length){
        const choices=wrappers.map(w=>({name:w.dataset.optionName||'',value:w.querySelector('.clickyboxes a.active')?.dataset.value||w.querySelector('select')?.value||''})).filter(x=>x.value);
        byOpts=product.variants.find(v=>choices.every(c=>{const idx=(product.options||[]).findIndex(o=>(typeof o==='string'?o:o.name)===c.name);return idx<0||v.options?.[idx]===c.value}));
      }
      const id=form.querySelector('[name="id"]')?.value;
      const byId=product?.variants?.find(v=>String(v.id)===String(id));
      return byOpts||byId||product?.selected_or_first_available_variant||product?.variants?.[0]||null;
    }
    const money=value=>new Intl.NumberFormat(document.documentElement.lang?.startsWith('en')?'en-GB':'fr-FR',{style:'currency',currency:window.Shopify?.currency?.active||'EUR',minimumFractionDigits:0,maximumFractionDigits:2}).format(value/100);
    function refresh(){
      const v=selectedVariant();const selected=[...area.querySelectorAll('.product-detail__form__options .selector-wrapper[data-option-name]')].map(w=>({name:w.dataset.optionName||'',value:w.querySelector('.clickyboxes a.active')?.dataset.value||w.querySelector('select')?.value||''})).filter(x=>x.value&&!/sans couvercle/i.test(x.value));
      variant.textContent=selected.map(o=>o.value.replace(/ \((Grand|Petit)\)/gi,'').replace('Gaz, Elect, Vitro, Halogène','Gaz / vitro / électrique')).slice(0,3).join(' · ')||'Choisir les options';
      qty.textContent=String(getQty());dec.disabled=getQty()<=1;
      const disabled=original.disabled||original.getAttribute('aria-disabled')==='true'||v?.available===false;
      buy.disabled=!!disabled;
      const preorder=/pr[eé]command/i.test(original.textContent||'');
      buyLabel.textContent=disabled?'Indisponible':(preorder?'Précommander':'Ajouter au panier');
      buyPrice.textContent=v?.price!=null?' · '+money(v.price):'';
      const alma=area.querySelector('[data-gwe-alma-installment]');
      if(alma&&v?.price!=null)alma.textContent=money(Math.round(v.price/3));
      if(photo&&v?.featured_image?.src&&photo.dataset.variantImage!==String(v.id)){
        photo.src=v.featured_image.src;photo.dataset.variantImage=String(v.id);
      }
    }
    let task;
    function schedule(){clearTimeout(task);task=setTimeout(refresh,80)}
    area.addEventListener('change',schedule);
    area.addEventListener('click',e=>{if(e.target.closest('.selector-wrapper,.options--diametre,[data-quantity]'))schedule()});
    document.addEventListener('variant:change',schedule);
    document.addEventListener('variant:changed',schedule);
    form.addEventListener('input',e=>{if(e.target.name==='quantity'||e.target.name==='id')schedule()});
    const watch=new MutationObserver(schedule);
    watch.observe(original,{attributes:true,attributeFilter:['disabled','aria-disabled'],childList:true,subtree:true});
    const opt=area.querySelector('.product-detail__form__options');
    if(opt)watch.observe(opt,{attributes:true,attributeFilter:['class','selected','value'],subtree:true});
    let intersect=null;
    function visible(){
      const openDrawer=document.querySelector('cart-drawer dialog[open],.cart-drawer.active,.gwe-facets-portal.is-open');
      const show=!intersect&&window.scrollY>200&&!openDrawer;
      bar.classList.toggle('floating-atc--show',show);
      const height=show?Math.ceil(bar.getBoundingClientRect().height):0;
      document.documentElement.style.setProperty('--gwe-sticky-atc-offset',height+'px');
      document.body.classList.toggle('gwe-sticky-atc-visible',show&&height>0);
    }
    const observer=new IntersectionObserver(entries=>{intersect=entries[0]?.isIntersecting;visible()},{rootMargin:'0px 0px -12% 0px',threshold:0});
    observer.observe(originalWrap);
    window.addEventListener('scroll',visible,{passive:true});
    window.addEventListener('resize',visible,{passive:true});
    document.addEventListener('cart:updated',visible);
    document.addEventListener('click',()=>setTimeout(visible,50));
    refresh();visible();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
